var _methods;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { protocolWarrantyInput_check, protocolWarrantyInput_submit, protocolWarrantyInput_buLuQuery, getApplicationProtocolSerialNo } from '@/api/protocolColdChain';
import { excleCargoDownload_biaodi, imageUploads_fun } from "@/api/policymanagement";
import { upLoads, deleteUpLoads, BASE, ECARGO_PATH } from '@/api/apis';
import Divier from "../contextmenu/divier";
import { formatMoney } from '@/utils/util';
import { download, getExcelPath } from "@/api/baseDataManage";
export default {
  name: 'protocolPolicyLuRu',
  components: {
    Divier: Divier
  },
  data: function data() {
    var _ref;

    return _ref = {
      tableData: [{
        insurance: '内陆货物运输险',
        insuranceDuty: '在运输途中由于冷藏机器或隔温设备的损坏所造成保险标的解冻溶化而腐败的损失',
        amount: '进口购买货物金额总额\n即：报关单所载货物单价×货物数量×110%\n\n且，单柜最高保额 200万，单一客户单航次累计限额不超过400万',
        deductible: 'RMB1万元或损失金额的15%，以高者为准',
        rate: '0.9‰',
        isInsure: ''
      }, {
        insurance: '内陆货物运输险',
        insuranceDuty: '在进口港或进口地经当地海关或卫生防疫当局检验证明，保险标的的外包装、' + '运输保险标的的集装箱内壁因含有2019新型冠状病毒并且超过了进口国对该病毒的限制要求保险标的被销毁的损失',
        amount: '',
        deductible: '',
        rate: '',
        isInsure: ''
      }, {
        insurance: '食品安全责任险（可选）',
        insuranceDuty: '保险标的因检测出含有2019新型冠状病毒造成消费、食用者人身伤亡或财产损失',
        amount: '200万元/保单累计；\n' + '50万元/每次事故；\n' + '2万元/每人；\n' + '2万元/法律费用\n',
        deductible: '损失金额的10%',
        rate: '0.15‰ \n 投保期初收取最低保费1000元',
        isInsure: ''
      }],
      checked1: true,
      checked: false,
      premiumView: '',
      transPortAmountView: '',
      // 协议保单信息
      allData: {
        agreementEndDate: '',
        agreementStartDate: '',
        applicationNo: '',
        applicationStatus: '',
        endDate: '',
        identifyNumber: '',
        insuredGoods: '',
        insuredName: '',
        insureds: [],
        mainRate: '',
        premium: '',
        protocolNo: '',
        protocolRate: '',
        protocolRate1: '',
        //保险费率
        rtnCode: '',
        rtnMsg: '',
        startDate: '',
        submitTime: '',
        transPortAmount: ''
      },
      rememberMe: true,
      protocolPolicy: {
        protocolNo: '',
        //协议保单号
        agreementStartDate: '',
        //协议开始日期
        agreementEndDate: '',
        //协议终止日期
        insuredName: '',
        //被保险人名称
        identifyNumber: '',
        //社会统一信用代码
        protocolRate: '',
        //保险费率
        protocolRate1: '',
        //保险费率
        submitType: '',
        applicationNo: '',
        serialNo: ''
      },
      // 投保意向信息
      insureIntent: {
        applicationNo: '',
        // 投保意向单号
        applicationStatus: '',
        // 投保意向书状态
        endDate: '',
        // 保险止期(yyyy-MM-dd HH:mm:ss)
        insuredGoods: '保险期间内被保险人自上海港入境的所有冷链食品',
        // 被保险货物
        premium: '',
        // 险费预估（人民币）(BigDecimal)
        mainRate: '0.8',
        // 保险费率
        startDate: '',
        // 保险起期(yyyy-MM-dd HH:mm:ss)
        submitTime: '',
        // 提交日期
        transPortAmount: '',
        // 年运输额（预估）（人民币）BigDecimal类型
        rememberMe: true,
        submitType: '',
        packingMethod: '',
        transportMeans: '',
        insurancecompanycode: '',
        insurancecompanyname: '',
        companyname: '',
        companycode: '',
        checked: ''
      },
      // 投保人信息
      applicant: {
        address: '',
        applicationNo: '',
        // --投保意向单号
        identifyNumber: '',
        identifyType: '10',
        // 统一社会信用代码
        identifyTypeCode: '',
        // 03
        insuredCode: '',
        insuredEnName: '',
        insuredName: '',
        insuredType: '1',
        phone: '',
        remark: '',
        serialNo: 1,
        linkmanName: '' //--联系人

      },
      // 被保险人信息
      insurant: {
        address: '',
        // --联系地址
        applicationNo: '',
        // --投保意向单号
        identifyNumber: '',
        // --证件号
        identifyType: '',
        // --证件类型名称
        identifyTypeCode: '',
        // --证件类型
        insuredCode: '',
        // --关系人代码
        insuredEnName: '',
        // --关系人英文名称
        insuredName: '',
        // --关系人名称
        linkmanName: '',
        //--联系人
        insuredType: '2',
        // --投保人/被保险人类型-"1投保人,2被保险人
        phone: '' // --联系电话

      },
      other: {
        applicationNo: '',
        //投保意向申请单号
        applicationStatus: '',
        //投保申请单状态
        submitDate: '' //提交日期

      },
      isTrue: false,
      rateFlag: false,
      fileList: [],
      // 文件list
      fileList1: [],
      //修改时上传的影像文件
      electActive: false,
      BASE_PATH: BASE + ECARGO_PATH,
      otherDatas_1: {
        type: '1',
        applicationNo: '',
        insuranceCompanyCode: '',
        insuranceCompanyName: ''
      },
      upLoadFlag: false,
      delType: '',
      dialogImageUrl: '',
      isCanUpload: false,
      //补录协议保单协议
      fileList_1: [],
      // 文件list
      allDisabled: false,
      // 查看view  禁用
      userDisable: false,
      isSureUpload: false,
      // 上传影像按钮的显示与隐藏
      isModify: false,
      isChangeld: false,
      goBack: true,
      protocolNoFlag: true,
      insureds: [],
      type: '',
      //查看 修改
      serialNo: 0,
      //查看时传递的该协议保单的序号 区分禁用和生效
      params: {
        type: '',
        serialNo: 0,
        applicantNo: '',
        protocolNo: ''
      },
      idCard_option: [{
        value: '10',
        label: '统一社会信用代码'
      }, {
        value: '01',
        label: '身份证'
      }, {
        value: '02',
        label: '户口簿'
      }, {
        value: '03',
        label: '护照'
      }, {
        value: '04',
        label: '军官证'
      }, {
        value: '05',
        label: '驾驶执照'
      }, {
        value: '06',
        label: '返乡证'
      }, {
        value: '07',
        label: '复原/退伍证号码'
      }, {
        value: '1',
        label: '组织机构代码证'
      }, {
        value: '3',
        label: '营业执照'
      }, {
        value: '9',
        label: '其他证件'
      }],
      // 证件类型数组
      whole_flag_s: false
    }, _defineProperty(_ref, "type", ''), _defineProperty(_ref, "options", [{
      value: '0',
      label: '暂存成功'
    }, {
      value: '1',
      label: '提交成功'
    }, {
      value: '2',
      label: '已生效'
    }]), _defineProperty(_ref, "formRules", {
      phone: [{
        required: true,
        message: '请输入移动电话',
        trigger: 'blur'
      }, {
        pattern: /^1[3|4|5|7|8|6][0-9]{9}$/,
        message: '移动电话格式不正确'
      }],
      address: [{
        required: true,
        message: '请输入地址',
        trigger: 'blur'
      }]
    }), _defineProperty(_ref, "listRules", {
      phone: [{
        required: true,
        message: '请输入移动电话',
        trigger: 'blur'
      }, {
        pattern: /^1[3|4|5|7|8|6][0-9]{9}$/,
        message: '移动电话格式不正确'
      }],
      address: [{
        required: true,
        message: '请输入地址',
        trigger: 'blur'
      }]
    }), _defineProperty(_ref, "applicanRules", {
      startDate: [{
        required: true,
        message: '请输入保险起期',
        trigger: 'change'
      }],
      endDate: [{
        required: true,
        message: '请输入保险止期',
        trigger: 'change'
      }],
      transPortAmount: [{
        required: true,
        message: '请输入年运输额(预估)(人民币)',
        trigger: 'change'
      }],
      submitTime: [{
        required: true,
        message: '请输入提交日期',
        trigger: 'change'
      }]
    }), _ref;
  },
  mounted: function mounted() {},
  created: function created() {
    console.log('打印传过去的参数', this.$route.params);
    this.type = this.$route.params.type;
    this.serialNo = this.$route.params.serialNo;

    if ("modify" == this.type || "view" == this.type) {
      this.getQueryInfo(this.type);
    } else {
      this.getBuLuInfo(this.type);
    }

    if ("modify" == this.type) {
      this.protocolPolicy.submitType = '2';
      this.protocolPolicy.serialNo = this.$route.params.serialNo;
      this.protocolPolicy.applicationNo = this.$route.params.applicationNo;
    } else if ("buLu" == this.type) {
      this.protocolPolicy.submitType = '1';
      this.protocolPolicy.applicationNo = this.$route.params.applicationNo;
    }
  },
  methods: (_methods = {
    setLPhone: function setLPhone(tel) {
      if (tel.indexOf("-") != -1) {
        tel = " " + tel;
        var str = " ";
        str = tel.substring(0, 3) + "****" + tel.substring(9);
        return str;
      } else {
        var _str = "";
        var reg = /(\d{3})\d{4}(\d{4})/; //正则表达式

        _str = tel.replace(reg, "$1****$2");
        return _str;
      }
    },
    setLListPhone: function setLListPhone(tel) {
      if (tel.indexOf("-") != -1) {
        tel = " " + tel;
        var str = " ";
        str = tel.substring(0, 3) + "****" + tel.substring(9);
        return str;
      } else {
        var _str2 = "";
        var reg = /(\d{3})\d{4}(\d{4})/; //正则表达式

        _str2 = tel.replace(reg, "$1****$2");
        return _str2;
      }
    },
    setLApplicationAddress: function setLApplicationAddress(tel) {
      // 投保人 联系人地址
      if (tel.length > 4) {
        tel = " " + tel;
        var str = " ";
        str = tel.slice(0, -4) + "****";
        return str;
      } else {
        tel = " " + tel;
        var _str3 = " ";
        _str3 = tel.slice(0, 0) + "****";
        return _str3;
      }
    },
    setLListAddress: function setLListAddress(tel) {
      //被保人 联系人地址
      if (tel.length > 4) {
        tel = " " + tel;
        var str = " ";
        str = tel.slice(0, -4) + "****";
        return str;
      } else {
        tel = " " + tel;
        var _str4 = " ";
        _str4 = tel.slice(0, 0) + "****";
        return _str4;
      }
    },
    changeStartDate: function changeStartDate(date) {
      console.log('选中的date', date); // console.log('当前日期时间戳', currentDate.setDate(currentDate.getDate()))

      var d = new Date(date);
      d.setDate(d.getDate());
      var currentDate = new Date();
      console.log('当前日期1', currentDate);
      console.log('当前日期时间戳', currentDate.setDate(currentDate.getDate()));
      console.log('选中的日期时间戳d.setDate(d.getDate())', d.setDate(d.getDate()));

      if (d.setDate(d.getDate()) < currentDate.setDate(currentDate.getDate())) {
        this.$message({
          message: '保险起期应大于当前日期！',
          type: 'error',
          duration: 3000
        });
        this.protocolPolicy.agreementStartDate = '';
        return false;
      } else {
        var endDate = new Date(new Date(date).setFullYear(d.getFullYear() + 1));
        console.log('endDate111', endDate);
        var timestamp = endDate.setDate(endDate.getDate());
        timestamp = timestamp / 1000;
        console.log('timestamp1', timestamp);
        console.log('timestamp2', timestamp);
        timestamp -= 86400; // 加一天

        console.log('timestamp3', timestamp);
        timestamp = timestamp * 1000;
        console.log('timestamp4', timestamp);
        var da = new Date(timestamp);
        var year = da.getFullYear();
        var month = da.getMonth() + 1;
        var date = da.getDate();
        var createDate = [year, month, date].join('-');
        console.log('createDate', createDate);
        this.protocolPolicy.agreementEndDate = createDate;
        console.log('起期this.applicationReqDto.startDate--', this.protocolPolicy.agreementStartDate);
        console.log('止期this.applicationReqDto.endDate--', this.protocolPolicy.agreementEndDate);
      }
    },
    objectSpanMethod: function objectSpanMethod(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (columnIndex !== 1) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    checkProtocolNo: function checkProtocolNo(e) {
      var value = e.target.value;
      console.log('投保协议号value---', value);
      var regExp = /^[A-Za-z0-9]+$/g;

      if (!regExp.test(value)) {
        this.$message({
          message: '请输入正确的投保协议号！',
          type: 'error',
          duration: 3000
        });
        return false;
      }
    },
    changeSelected: function changeSelected(val) {
      console.log('是否选中', val);

      if (val) {
        this.rememberMe = true;
      } else {
        this.rememberMe = false;
      }
    },
    changeName: function changeName() {
      if (!this.protocolPolicy.insuredName) {
        this.$message({
          message: '被保险人名称不能为空',
          type: 'error',
          duration: 3000
        });
        return false;
      }
    }
  }, _defineProperty(_methods, "changeName", function changeName() {
    if (!this.protocolPolicy.protocolRate) {
      this.$message({
        message: '费率不能为空',
        type: 'error',
        duration: 3000
      });
      return false;
    }
  }), _defineProperty(_methods, "changeIdNumber", function changeIdNumber(e) {
    var value = e.target.value;
    console.log('证件号value---', value);
    var regExp = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g;

    if (!regExp.test(value)) {
      this.$message({
        message: '请输入正确的统一社会信用代码',
        type: 'error',
        duration: 3000
      });
      this.isChangeld = true;
      return false;
    } else {
      this.isChangeld = false;
    }
  }), _defineProperty(_methods, "success_img", function success_img(response, file, fileList) {
    console.log('fileList====', fileList);
    this.fileList = fileList;
  }), _defineProperty(_methods, "handlePictureCardPreview", function handlePictureCardPreview(file) {
    if (this.type == 'modify') {
      this.fileList1.push(file);
    } else {
      this.fileList.push(file);
    }
  }), _defineProperty(_methods, "look_img", function look_img(file) {
    var data = {};
    console.log("***********************", file);

    if (file.fileSrc) {
      data = {
        fileSrc: file.fileSrc
      };
      excleCargoDownload_biaodi(data).then(function (res) {
        var blob = new Blob([res], {
          type: ""
        });
        var url = window.URL.createObjectURL(blob);
        console.log(url);
        var link = document.createElement("a"); // 创建a标签

        link.href = url;
        link.download = file.name; // 重命名文件

        link.click();
        URL.revokeObjectURL(url); // 释放内存
      });
    } else {
      console.log('11111111', file.response.detailDtoList[0].fileSrc);
      var fileSrc = file.response.detailDtoList[0].fileSrc;
      excleCargoDownload_biaodi({
        fileSrc: fileSrc
      }).then(function (res) {
        var blob = new Blob([res], {
          type: ""
        });
        var url = window.URL.createObjectURL(blob);
        console.log('url11111111111', url);
        var link = document.createElement("a"); // 创建a标签

        link.href = url;
        link.download = file.name; // 重命名文件

        link.click();
        URL.revokeObjectURL(url); // 释放内存
      });
    }
  }), _defineProperty(_methods, "handleRemove", function handleRemove(file, fileList) {
    var _this = this;

    console.log('基础信息的file', file);

    if (this.type == 'view') {
      this.$message({
        type: 'success',
        message: '查看不允许删除影像'
      });
    } else {
      this.fileList = fileList;

      if (file.imagCode) {
        deleteUpLoads({
          imagCode: file.imagCode,
          delType: 'coldChain'
        }).then(function (res) {
          if (res.rtnCode == "0000") {
            _this.$message({
              type: 'success',
              message: res.rtnMsg
            });

            _this.fileList = fileList;
          }
        });
      }

      if (file.response.detailDtoList[0].imagCode) {
        deleteUpLoads({
          imagCode: file.response.detailDtoList[0].imagCode
        }).then(function (res) {
          if (res.rtnCode == "0000") {
            _this.$message({
              type: 'success',
              message: res.rtnMsg
            });

            _this.fileList = fileList;
          }
        });
      }
    }
  }), _defineProperty(_methods, "beforeUploadimg", function beforeUploadimg(file) {
    console.log('file900--', file);
    var isLt2M = file.size / 1024 / 1024 < 5;
    var isold = true;
    var isnumber = true; //判断文件名是否重复

    var count = 0;
    this.fileList.forEach(function (item, idx) {
      if (idx > 19) {
        isnumber = false;
      }

      if (file.name == item.name) {
        count++;

        if (count == 1) {
          isold = true;
        }

        if (count === 2) {
          isold = false;
        }
      }
    });

    if (!isold) {
      this.$message({
        message: '上传文件已存在，请确认后重新上传!',
        type: 'warning'
      });
    }

    if (!isLt2M) {
      this.$message({
        message: '上传文件大小不能超过 5MB!',
        type: 'warning'
      });
    }

    if (!isnumber) {
      this.$message({
        message: '最多支持上传20个文件!',
        type: 'warning'
      });
    }

    return isLt2M && isold && isnumber;
  }), _defineProperty(_methods, "httpRequest", function httpRequest(data) {
    console.log('data==', data);
  }), _defineProperty(_methods, "submitUpload", function submitUpload(type) {
    var _this2 = this;

    console.log('上传文件的type', type);
    console.log('上传文件的type', this.type);
    console.log(this.fileList.length);
    console.log(this.fileList1.length);
    console.log(this.serialNo);
    var j = 0;
    var newarray = [];
    var dataFile = new FormData();

    if (this.type == 'modify') {
      for (var i = 0; i < this.fileList1.length; i++) {
        if (this.fileList1[i].raw && this.fileList1[i].type != "old") {
          if (j < 10) {
            dataFile.append('files', this.fileList1[i].raw);
            this.fileList1[i]['type'] = 'old';
          }

          j++;
        }
      }
    } else {
      for (var i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].raw && this.fileList[i].type != "old") {
          if (j < 10) {
            dataFile.append('files', this.fileList[i].raw);
            this.fileList[i]['type'] = 'old';
          }

          j++;
        }
      }
    }

    dataFile.append('type', type);
    dataFile.append('serialNo', this.serialNo);
    dataFile.append('applicationNo', this.other.applicationNo);
    dataFile.append('protocolNo', this.protocolPolicy.protocolNo);
    dataFile.append('insuranceCompanyCode', this.insureIntent.insurancecompanycode);
    dataFile.append('insuranceCompanyName', this.insureIntent.insurancecompanyname);
    upLoads(dataFile).then(function (res) {
      console.log('res影像上传成功后的结果', res);

      if (res.rtnCode == "0000") {
        var k = 0;

        if (_this2.type == 'modify') {
          for (var i = 0; i < _this2.fileList1.length; i++) {
            // console.log(this.fileList)
            if (!_this2.fileList1[i].imagCode && k < 10) {
              _this2.fileList1[i].fileSrc = res.detailDtoList[k].fileSrc;
              _this2.fileList1[i].imagCode = res.detailDtoList[k].imagCode;
              _this2.fileList1[i].applicationNo = res.detailDtoList[k].applicationNo;
              newarray.push(_this2.fileList1[i]);
              k++;
            }
          }
        } else {
          for (var i = 0; i < _this2.fileList.length; i++) {
            // console.log(this.fileList)
            if (!_this2.fileList[i].imagCode && k < 10) {
              _this2.fileList[i].fileSrc = res.detailDtoList[k].fileSrc;
              _this2.fileList[i].imagCode = res.detailDtoList[k].imagCode;
              _this2.fileList[i].applicationNo = res.detailDtoList[k].applicationNo;
              newarray.push(_this2.fileList[i]);
              k++;
            }
          }
        }

        console.log('newarray.length', newarray.length);

        if (newarray.length > 9) {
          // console.log("00000",this.fileList.length)
          _this2.submitUpload2();
        } else {
          _this2.$message({
            duration: 3000,
            message: res.data,
            type: 'success'
          }); // $(".el-upload-list__item-status-label").css("display","block")

        }
      } else {
        _this2.$message({
          duration: 3000,
          message: '没有待上传的影像',
          type: 'error'
        });
      }
    });
  }), _defineProperty(_methods, "handleRemove_1", function handleRemove_1(file, fileList) {
    console.log('文件管理制度的file', file); // if(file.imagCode){
    //   deleteUpLoads({imagCode:file.imagCode}).then(res => {
    //     if(res.rtnCode == "0000"){
    //       this.$message({
    //         type: 'success',
    //         message: res.rtnMsg
    //       })
    //       this.fileList_1 = fileList
    //     }
    //
    //   })
    // }
    // if(file.response.detailDtoList[0].imagCode){
    //   deleteUpLoads({imagCode:file.response.detailDtoList[0].imagCode}).then(res => {
    //     if(res.rtnCode == "0000"){
    //       this.$message({
    //         type: 'success',
    //         message: res.rtnMsg
    //       })
    //       this.fileList_1 = fileList
    //       console.log('this.fileList===11',this.fileList_1)
    //     }
    //   })
    // }
  }), _defineProperty(_methods, "success_img_1", function success_img_1(response, file, fileList) {
    console.log('response====', response);
    console.log('file====', file);
    console.log('fileList====', fileList);

    if (response.rtnCode == '0000') {
      this.hasUplaod = true;
    }

    this.fileList_1 = file;
    console.log('this.fileList_1====', this.fileList_1);
  }), _defineProperty(_methods, "beforeUploadimg_1", function beforeUploadimg_1(file) {
    var _this3 = this;

    console.log('file--', file); // this.fileList_1.push(file)

    var mimes = {
      xls: 'application/vnd.ms-excel',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      pdf: 'application/pdf',
      doc: 'application/msword',
      docs: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png'
    };
    return new Promise(function (resolve, reject) {
      var isJPG = file.type === 'image/jpeg';
      var isPNG = file.type === 'image/png'; // if (!this.isSureUpload) {
      //   this.$message.error(`请先点击暂存`)
      //   return reject()
      // }

      var flag = false; // if(file.type == mimes.pdf || file.type == mimes.doc || file.type == mimes.docs){
      //   flag = true
      // }
      // if(!flag) {
      //   this.$message.error(`上传的文件只能是pdf/word格式!`)
      //   return reject()
      // }

      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; //判断文件名是否重复

      var count = 0;

      _this3.fileList_1.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        _this3.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        _this3.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });

        _this3.fileList_1 = [];
        console.log('文件置空==');
        return reject();
      }

      if (!isnumber) {
        _this3.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      resolve();
    });
  }), _defineProperty(_methods, "addUpload_1", function addUpload_1(type) {
    console.log(type);
    console.log("协议保单号:" + this.protocolPolicy.protocolNo);
    console.log("协议保单号:" + this.insureIntent.applicationNo);
    console.log("保险公司代码:" + this.insureIntent.insurancecompanycode);
    console.log("保险公司名称:" + this.insureIntent.insurancecompanyname);
    this.otherDatas_1.type = type;
    this.otherDatas_1.applicationNo = this.other.applicationNo;
    this.otherDatas_1.insuranceCompanyCode = this.insureIntent.insurancecompanycode;
    this.otherDatas_1.insuranceCompanyName = this.insureIntent.insurancecompanyname;
  }), _defineProperty(_methods, "showWords", function showWords() {
    var type;

    if (this.checked) {
      type = "coldFood";
    } else {
      type = "coldNoFood";
    }

    getExcelPath({
      fileDownloadType: type
    }).then(function (res) {
      console.log('预览res', res); // 获取下载文件

      download({
        fileSrc: res.fileSrc
      }).then(function (res2) {
        var blob = new Blob([res2], {
          type: 'application/vnd.ms-pdf'
        }); // 兼容ie

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, '《进口冷链食品防疫综合保险》投保须知及条款.pdf');
        } else {
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a'); // 创建a标签

          link.href = url;
          link.download = '《进口冷链食品防疫综合保险》投保须知及条款.pdf'; // 重命名文件

          link.click();
          window.URL.revokeObjectURL(url); // 释放内存
        }
      });
    });
  }), _defineProperty(_methods, "getQueryInfo", function getQueryInfo(type) {
    var _this4 = this;

    protocolWarrantyInput_check({
      applicationNo: this.$route.params.applicationNo,
      serialNo: this.serialNo,
      protocolNo: this.$route.params.protocolno
    }).then(function (res) {
      console.log('res--', res);
      console.log(type);

      if ("view" == type) {
        _this4.isTrue = true;
        _this4.isModify = true;
        _this4.goBack = false;
        _this4.rememberMe = true;
        _this4.upLoadFlag = true;
        _this4.allDisabled = true;
      } else if ("modify" == type) {
        _this4.isTrue = false;
        _this4.isModify = true;
        _this4.rememberMe = true;
        _this4.upLoadFlag = true;
        _this4.allDisabled = false;
      }

      _this4.applicant = res.insureds[0];
      _this4.insurant = res.insureds[1];

      if ("view" == type) {
        //this.$set
        _this4.protocolPolicy.agreementStartDate = res.agreementStartDate;
        _this4.protocolPolicy.agreementEndDate = res.agreementEndDate;
        _this4.protocolPolicy.identifyNumber = res.identifyNumber;
        _this4.protocolPolicy.insuredName = res.insuredName;
        _this4.protocolPolicy.protocolRate = res.protocolRate;
        _this4.protocolPolicy.protocolRate1 = res.protocolRate1;
        _this4.protocolPolicy.protocolNo = res.protocolNo;
      } else {
        _this4.protocolPolicy.agreementStartDate = res.agreementStartDate;
        _this4.protocolPolicy.agreementEndDate = res.agreementEndDate;
        _this4.protocolPolicy.identifyNumber = res.identifyNumber;
        _this4.protocolPolicy.insuredName = res.insuredName;
        _this4.protocolPolicy.protocolRate = res.protocolRate;
        _this4.protocolPolicy.protocolRate1 = res.protocolRate1;
        _this4.protocolPolicy.protocolNo = res.protocolNo;
      }

      if (res.imagList && res.imagList.length > 0) {
        for (var i = 0; i < res.imagList.length; i++) {
          var obj = {};
          var formData = new FormData();
          var base64 = 'data:image/png;base64,' + res.imagList[i].base64Src;
          var imagCode = res.imagList[i].imagCode;
          var applicationNo = res.imagList[i].applicationNo;
          var fileSrc = res.imagList[i].fileSrc;
          var fileName = res.imagList[i].fileName; //转换base64到file

          var toFile = require('data-uri-to-file');

          toFile(base64).then(function (filed) {
            console.log(filed.mimeType, filed.data, filed.extension);
            formData.append("imageName", filed);
            obj.raw = filed;
          }); //var file = this.base64ToFile(base64);
          // console.log(file)
          //formData.append("imageName", file);

          obj.name = fileName; //obj.raw = file;

          obj["type"] = "old";
          obj["url"] = base64;
          obj["fileSrc"] = fileSrc;
          obj.imagCode = imagCode;
          obj.applicationNo = applicationNo;

          _this4.fileList.push(obj);

          console.log('获取this.fileList', _this4.fileList);
        }
      }

      _this4.other.applicationNo = res.applicationNo;
      _this4.other.applicationStatus = res.applicationStatus;
      _this4.other.submitDate = res.submitTime;
      _this4.insureIntent.startDate = res.startDate;
      _this4.insureIntent.endDate = res.endDate;
      _this4.insureIntent.insuredGoods = res.insuredGoods;
      _this4.insureIntent.transPortAmount = res.transPortAmount;
      _this4.insureIntent.premium = res.premium;
      _this4.insureIntent.mainRate = res.mainRate;
      _this4.insureIntent.packingMethod = res.packingMethod;
      _this4.insureIntent.transportMeans = res.transportMeans;
      _this4.insureIntent.insurancecompanycode = res.insuranceCompanyCode;
      _this4.insureIntent.insurancecompanyname = res.insuranceCompanyName;
      _this4.insureIntent.companyname = res.companyName;
      _this4.insureIntent.companycode = res.companyCode;
      _this4.insureIntent.checked = res.checked;
      _this4.checked = res.checked == '1';

      _this4.qfhView();

      if ("view" == type) {
        //投保人 联系人电话脱敏
        if (_this4.applicant.phone != null && _this4.applicant.phone != '') {
          _this4.applicant.phone = _this4.setLPhone(_this4.applicant.phone);
        } //被保险人 联系人电话脱敏


        if (_this4.insurant.phone != null && _this4.insurant.phone != '') {
          _this4.insurant.phone = _this4.setLListPhone(_this4.insurant.phone);
        } //投保人 联系地址脱敏


        if (_this4.applicant.address != null && _this4.applicant.address != '') {
          _this4.applicant.address = _this4.setLApplicationAddress(_this4.applicant.address);
        } //被保人 联系地址脱敏


        if (_this4.insurant.address != null && _this4.insurant.address != '') {
          _this4.insurant.address = _this4.setLListAddress(_this4.insurant.address);
        }
      }
    });
  }), _defineProperty(_methods, "getBuLuInfo", function getBuLuInfo(type) {
    var _this5 = this;

    protocolWarrantyInput_buLuQuery({
      applicationNo: this.$route.params.applicationNo
    }).then(function (res) {
      console.log('res--', res);
      console.log(type);

      if ("view" == type) {
        _this5.isTrue = true;
        _this5.isModify = true;
        _this5.goBack = false;
        _this5.rememberMe = true;
        _this5.protocolNoFlag = true;
      } else if ("modify" == type) {
        _this5.isTrue = false;
        _this5.isModify = true;
        _this5.goBack = true;
        _this5.rememberMe = true;
        _this5.protocolNoFlag = true;
      } else {
        _this5.isTrue = false;
        _this5.isModify = false;
        _this5.protocolNoFlag = false;
      }

      _this5.applicant = res.insureds[0];
      _this5.insurant = res.insureds[1];

      if (_this5.applicant == undefined) {
        _this5.$message({
          message: '该投保意向申请单号暂无投保人信息!',
          type: 'error',
          duration: 5000
        });

        _this5.$router.push({
          name: 'prtocolWarrantyInput'
        });
      } else if (_this5.insurant == undefined) {
        _this5.$message({
          message: '该投保意向申请单号暂无被保险人信息!',
          type: 'error',
          duration: 5000
        });

        _this5.$router.push({
          name: 'prtocolWarrantyInput'
        });
      }

      if ("buLu" == type) {
        //this.$set
        _this5.other.applicationNo = res.applicationNo;
        _this5.other.applicationStatus = res.applicationStatus;
        _this5.other.submitDate = res.submitTime;
        _this5.insureIntent.startDate = res.startDate;
        _this5.insureIntent.endDate = res.endDate;
        _this5.insureIntent.insuredGoods = res.insuredGoods;
        _this5.insureIntent.transPortAmount = res.transPortAmount;
        _this5.insureIntent.premium = res.premium;
        _this5.insureIntent.mainRate = res.mainRate;
        _this5.protocolPolicy.insuredName = _this5.insurant.insuredName;
        _this5.protocolPolicy.identifyNumber = _this5.insurant.identifyNumber;
        _this5.protocolPolicy.agreementStartDate = res.startDate;
        _this5.protocolPolicy.agreementEndDate = res.endDate;
        _this5.protocolPolicy.protocolRate = '0.9';

        if (res.checked == '1') {
          _this5.protocolPolicy.protocolRate1 = '0.15';
        }

        _this5.insureIntent.packingMethod = res.packingMethod;
        _this5.insureIntent.transportMeans = res.transportMeans;
        _this5.insureIntent.applicationNo = res.applicationNo;
        _this5.insureIntent.insurancecompanycode = res.insuranceCompanyCode;
        _this5.insureIntent.insurancecompanyname = res.insuranceCompanyName;
        _this5.insureIntent.companyname = res.companyName;
        _this5.insureIntent.companycode = res.companyCode;
        _this5.insureIntent.checked = res.checked;
        _this5.checked = res.checked == '1';
      }

      _this5.qfhView();

      if ("view" == type) {
        //投保人 联系人电话脱敏
        if (_this5.applicant.phone != null && _this5.applicant.phone != '') {
          _this5.applicant.phone = _this5.setLPhone(_this5.applicant.phone);
        } //被保险人 联系人电话脱敏


        if (_this5.insurant.phone != null && _this5.insurant.phone != '') {
          _this5.insurant.phone = _this5.setLListPhone(_this5.insurant.phone);
        } //投保人 联系地址脱敏


        if (_this5.applicant.address != null && _this5.applicant.address != '') {
          _this5.applicant.address = _this5.setLApplicationAddress(_this5.applicant.address);
        } //被保人 联系地址脱敏


        if (_this5.insurant.address != null && _this5.insurant.address != '') {
          _this5.insurant.address = _this5.setLListAddress(_this5.insurant.address);
        }
      }
    });
  }), _defineProperty(_methods, "qfhView", function qfhView() {
    console.log(this.insureIntent.transPortAmount + '------');

    if (this.insureIntent.premium) {
      this.premiumView = formatMoney(this.insureIntent.premium, 2);
    }

    if (this.insureIntent.transPortAmount) {
      this.transPortAmountView = formatMoney(this.insureIntent.transPortAmount, 2);
    }
  }), _defineProperty(_methods, "shuRuAgreementStartDate", function shuRuAgreementStartDate(val) {
    if (val == null || val == "") {
      this.text1.proposalNo = "请输入投保单申请号";
    } else {
      this.text1.proposalNo = "";
    }
  }), _defineProperty(_methods, "change", function change(e) {
    this.$forceUpdate();
  }), _defineProperty(_methods, "saveButton", function saveButton() {
    var _this6 = this;

    if (this.isChangeld) {
      this.$message({
        message: '请输入正确的统一社会信用代码',
        duration: 3000
      });
      return false;
    }

    if ("modify" == this.type) {
      this.protocolPolicy.submitType = 2;
    }

    if (!this.protocolPolicy.protocolNo) {
      this.$message({
        message: '协议保单号不能为空！',
        duration: 3000
      });
      return false;
    } else {
      var regExp = /^[A-Za-z0-9]+$/g;

      if (!regExp.test(this.protocolPolicy.protocolNo)) {
        this.$message({
          message: '请输入正确的投保协议号！',
          type: 'error',
          duration: 3000
        });
        return false;
      }
    }

    if (!this.protocolPolicy.agreementStartDate) {
      this.$message({
        message: '协议开始日期不能为空！',
        duration: 3000
      });
      return false;
    }

    if (!this.protocolPolicy.agreementEndDate) {
      this.$message({
        message: '协议终止日期不能为空！',
        duration: 3000
      });
      return false;
    }

    if (!this.protocolPolicy.insuredName) {
      this.$message({
        message: '被保险人名称不能为空！',
        duration: 3000
      });
      return false;
    }

    if (!this.protocolPolicy.identifyNumber) {
      this.$message({
        message: '统一社会信用代码不能为空！',
        duration: 3000
      });
      return false;
    }

    if (!this.protocolPolicy.protocolRate) {
      this.$message({
        message: '运输险费率不能为空！',
        duration: 3000
      });
      return false;
    }

    if (this.checked && !this.protocolPolicy.protocolRate1) {
      this.$message({
        message: '食品安全险费率不能为空！',
        duration: 3000
      });
      return false;
    }

    var nowDateTime = new Date();
    console.log('nowDateTime', nowDateTime);

    if (this.protocolPolicy.agreementStartDate < nowDateTime) {
      this.$message({
        message: '协议开始日期应大于当前日期！',
        duration: 3000
      });
      return false;
    }

    if (this.protocolPolicy.agreementEndDate < nowDateTime) {
      this.$message({
        message: '协议终止日期应大于当前日期！',
        duration: 3000
      });
      return false;
    }

    if (!this.rememberMe) {
      this.$message({
        message: '提交前请阅读投保须知,并勾选！',
        duration: 3000
      });
      return false;
    }

    protocolWarrantyInput_submit({
      applicationNo: this.protocolPolicy.applicationNo,
      agreementStartDate: this.protocolPolicy.agreementStartDate,
      agreementEndDate: this.protocolPolicy.agreementEndDate,
      premium: this.protocolPolicy.protocolNo,
      protocolRate: this.protocolPolicy.protocolRate,
      protocolRate1: this.protocolPolicy.protocolRate1,
      submitType: this.protocolPolicy.submitType,
      serialNo: this.protocolPolicy.serialNo,
      protocolNo: this.protocolPolicy.protocolNo,
      insuredName: this.protocolPolicy.insuredName,
      identifyNumber: this.protocolPolicy.identifyNumber
    }).then(function (res) {
      console.log('打印保存---res', res);

      if (res.rtnCode == '0000' && _this6.protocolPolicy.submitType == '2') {
        _this6.$message({
          message: res.rtnMsg,
          type: 'success',
          duration: 5000
        });

        _this6.closeBar();

        _this6.$router.push({
          name: 'protocolWarrantyManagement'
        });
      } else if (res.rtnCode == '0000' && _this6.protocolPolicy.submitType == '1') {
        _this6.$message({
          message: res.rtnMsg,
          type: 'success',
          duration: 5000
        });

        _this6.closeBar(); // this.$router.push({
        //   name: 'protocolWarrantyManagement'
        // })


        _this6.protocolPolicy.protocolNo = res.protocolNo;
        _this6.protocolPolicy.agreementStartDate = res.agreementStartDate;
        _this6.protocolPolicy.agreementEndDate = res.agreementEndDate;
        _this6.protocolPolicy.insuredName = res.insuredName;
        _this6.protocolPolicy.identifyNumber = res.identifyNumber;
        _this6.protocolPolicy.protocolRate = res.protocolRate;
        _this6.protocolNoFlag = true;
        _this6.upLoadFlag = true;
        _this6.isTrue = true;
        _this6.rateFlag = false; //根据协议保单号和投保意向单号获取序号

        console.log(_this6.insureIntent.insurancecompanycode);
        getApplicationProtocolSerialNo({
          applicationNo: _this6.protocolPolicy.applicationNo,
          protocolNo: _this6.protocolPolicy.protocolNo,
          identifyNumber: _this6.protocolPolicy.identifyNumber,
          insuranceCompanyCode: _this6.insureIntent.insurancecompanycode
        }).then(function (res) {
          console.log('根据协议保单号和投保意向单号获取序号成功---res', res);

          if (res.rtnCode == '0000') {
            console.log("serialNo赋值成功");
            _this6.serialNo = res.serialNo;
          } else if (res.rtnCode == '9999') {
            _this6.$message({
              message: res.rtnMsg,
              type: 'error',
              duration: 5000
            });
          }
        });
      } else if (res.rtnCode == '9999' && _this6.protocolPolicy.submitType == '1') {
        _this6.$message({
          message: res.rtnMsg,
          type: 'error',
          duration: 5000
        });
        /* this.closeBar()
        this.$router.push({
          name: 'protocolWarrantyManagement'
        })*/

      } else {
        _this6.$message({
          message: res.rtnMsg,
          type: 'error',
          duration: 5000
        });

        _this6.closeBar();

        _this6.$router.push({
          name: 'protocolWarrantyManagement'
        });
      }
    });
  }), _defineProperty(_methods, "closeBar", function closeBar() {
    this.$store.dispatch('delVisitedViews', this.$route);
  }), _defineProperty(_methods, "cancelBtn", function cancelBtn() {
    // this.$router.push({ path: '/' })
    this.$router.go('-1'); // 关闭导航栏

    this.$store.dispatch('delVisitedViews', this.$route);
  }), _defineProperty(_methods, "renderHeader", function renderHeader(h, para) {
    return h('div', {
      attrs: {
        class: 'cell'
      },
      domProps: {
        innerHTML: '费率</br>（不含手续费费率）'
      }
    });
  }), _methods)
};